<template>
  <div ref="subTable" class="crosstab-title">
    <h3>
      <div class="title-1">Behavioral Risk Factor Surveillance System</div>
      <div class="title-2">
        Logistic Regression, {{ locations }}, {{ years }}
      </div>
      <div></div>
    </h3>
    <div>
      <div class="well">
        <div class="variable-types">
          <div class="dependent">
            <div>Dependent Variable:</div>
            <div>{{ reportModel.parms.dependentVariable.toString() }}</div>
          </div>
          <div
            style="line-height: 20px; margin-bottom: 5px"
            class="independent"
          >
            <div class="col-xs-4 col-md-5">Independent Variables:</div>
            <div class="col-xs-8 col-md-7">
              <div
                v-for="independentVariable in reportModel.parms
                  .independentVariables"
                v-bind:key="independentVariable.name"
              >
                {{ independentVariable.toString() }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import commonModelHelper from "@/scripts/commonModelHelper";
import store from "@/store";

export default {
  props: ["selectionModel", "reportModel"],
  data: function () {
    var vm = this;
    return {
      locations: commonModelHelper.getReportTitleLocations(
        store.state.selModel.locations
      ),
      years: commonModelHelper.getDisplayYearsWithAnd(),
    };
  },
  methods: {},
};
</script>

<style scoped>
.title-1 {
  text-align: center;
}

.title-2 {
  text-align: center;
  font-size: smaller;
}
/* col-xs-12 col-sm-10 col-md-8 col-sm-offset-1 col-md-offset-2 */
.well {
  min-height: 20px;
  padding: 19px;

  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%);
  box-sizing: border-box;
  margin-bottom: 20px;
}

div.variable-types div.row div {
  line-height: 20px;

  font-size: 14px;
  margin-bottom: 8px;
  /* min-height: 1px; */
}

div.variable-types {
  margin-bottom: -15px;
}

div.dependent,
div.independent {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  font-size: 14px;
}
div.dependent > div:first-child,
div.independent > div:first-child {
  float: left;
  width: 30%;
}

div.dependent > div:nth-child(2),
div.independent > div:nth-child(2) {
  float: left;
  width: 70%;
  margin-bottom: 10px;
}

div.dependent > div:nth-child(2) > div,
div.independent > div:nth-child(2) > div {
  margin-bottom: 10px;
}

div .controlling-for span {
  font-size: 16px;
  line-height: 21px;
}

@media (min-width: 768px) {
  .well {
    margin: 0 10px 20px 10px;
  }
}
</style>
